import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import currencyFormatter from 'currency-formatter';

import CONST from '@shared/task/constants';
import { forms as Forms } from '@breezeway/brzw-components';

const EMPTY_STRING = '';

const FormControlCurrencyInput = ({
  input: { onChange, value },
  meta: { touched, error, warning },
  currency,
  id,
  label,
  placeholder,
  required,
}) => {
  const selectedCurrency = currencyFormatter.findCurrency(currency) || CONST.DEFAULT_CURRENCY;
  const { symbolOnLeft, symbol: currencySymbol } = selectedCurrency;
  const defaultPlaceholder = symbolOnLeft ? `${currencySymbol}0.00` : `0.00${currencySymbol}`;
  const withError = touched && !_.isEmpty(error || warning);

  return (
    <Forms.CurrencyInput
      currencyPrefix={symbolOnLeft ? currencySymbol : EMPTY_STRING}
      currencySuffix={!symbolOnLeft ? currencySymbol : EMPTY_STRING}
      id={id}
      isRequired={required}
      labelText={label}
      onChange={onChange}
      placeholder={placeholder || defaultPlaceholder}
      value={value}
      withError={withError}
    />
  );
};

FormControlCurrencyInput.propTypes = {
  currency: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

export default FormControlCurrencyInput;
